import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';

Vue.use(VueI18n);

const defaultLanguage = document.documentElement.lang || 'en';
export const i18n = new VueI18n({
  locale: defaultLanguage, // set locale
  fallbackLocale: 'en',
  messages: {
    en: require('./lang/en/index').default,
    cy: require('./lang/cy/index').default,
  }
});

const loadedLanguages = [];

function setI18nLanguage(lang) {
  i18n.locale = lang;
  axios.defaults.headers.common['Accept-Language'] = lang;
  return lang
}

export function loadLanguageAsync (lang) {
  console.log(`Loading language 1: ${lang}`);
  if (i18n.locale !== lang) {
    console.log(`Loading language 2: ${lang}`);
    if (!loadedLanguages.includes(lang)) {
      console.log(`Loading language 3: ${lang}`);
      return import(/* webpackChunkName: "lang-[request]" */ `./lang/${lang}/index`).then(msgs => {
        i18n.setLocaleMessage(lang, msgs.default)
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
      })
    }
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}

if (module.hot) {
  const localePath = `./lang/${defaultLanguage}/index`;
  module.hot.accept([localePath], () => {
    i18n.setLocaleMessage(defaultLanguage, require(localePath).default)
  })
}
